import DepartmentSummary from "./DepartmentSummary";
export default DepartmentSummary;
